import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Blinker from './blinker';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

const useStyles = makeStyles(theme => ({
  header: {
    height: '80px',
    padding: '0 40px 0px 52px',
    overflow: 'hidden',
    display: 'flex',
    position: 'fixed',
    top: '0px',
    left: '0px',
    right: '0',
    fontSize: '11px',
    textAlign: 'center',
    backgroundColor: '#ffffff',
    zIndex: '10000',
    [theme.breakpoints.down('xs')]: {
      padding: '0 40px 0px 8px',
      height: '54px',
      top: '0',
      left: '0',
      fontSize: '9px',
    },
  },
  index: {
    opacity: '1',
    display: 'flex',
    alignItems: 'center',
  },
  nav: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  link: {
    height: '100%',
    padding: '20px 0',
    marginRight: '18px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden',
  },
  isActive: {},
  linkMarker: {
    content: '""',
    width: '100%',
    height: '2px',
    backgroundColor: '#000000',
    opacity: '1',
    position: 'absolute',
    bottom: '0',
    left: '0',
    transform: 'translate(0, 100%)',
  },
  showLinkMarker: {},
  logoImage: {
    width: '26px',
    [theme.breakpoints.up('sm')]: {
      width: '32px',
    },
  },
}));

const Header = props => {
  const [activeSection, setActiveSection] = useState('/');
  const classes = useStyles();
  const p = useRef(null);
  const a = useRef(null);
  const t = useRef(null);
  const c = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(ScrollToPlugin);
    gsap.to(p.current, {
      duration: 0.5,
      y: 0,
      duration: 0.8,
      ease: 'power4',
      scrollTrigger: {
        trigger: '#projects',
        // start: 'top 80%',
        // end: 'bottom 10%',
        toggleActions: 'play reverse play reverse',
      },
    });

    gsap.to(a.current, {
      duration: 0.5,
      y: 0,
      duration: 0.8,
      ease: 'power4',
      scrollTrigger: {
        trigger: '#about',
        // start: 'top 80%',
        // end: 'bottom 10%',
        toggleActions: 'play reverse play reverse',
      },
    });

    gsap.to(t.current, {
      duration: 0.5,
      y: 0,
      duration: 0.8,
      ease: 'power4',
      scrollTrigger: {
        trigger: '#technologies',
        // start: 'top 80%',
        // end: 'bottom 10%',
        toggleActions: 'play reverse play reverse',
      },
    });

    gsap.to(c.current, {
      duration: 0.5,
      y: 0,
      duration: 0.8,
      ease: 'power4',
      scrollTrigger: {
        trigger: '#contact',
        // start: 'top 80%',
        // end: 'bottom 10%',
        toggleActions: 'play reverse play reverse',
      },
    });
  }, []);
  const handleLinkClick = [
    e => {
      e.preventDefault();
      gsap.to(window, { duration: 1, scrollTo: '#projects' });
      setActiveSection('projects');
    },
    e => {
      e.preventDefault();
      gsap.to(window, { duration: 1, scrollTo: '#about' });
      setActiveSection('about');
    },
    e => {
      e.preventDefault();
      gsap.to(window, { duration: 1, scrollTo: '#technologies' });
      setActiveSection('techhnologies');
    },
    e => {
      e.preventDefault();
      gsap.to(window, { duration: 1, scrollTo: '#contact' });
      setActiveSection('contact');
    },
  ];
  return (
    <header className={classes.header}>
      <a className={classes.index} href="/">
        <img
          src={require('../assets/images/ma-logo.svg')}
          className={classes.logoImage}
          alt=""
        />
      </a>
      <Blinker />
      <nav className={classes.nav}>
        <a
          className={`${classes.link} ${
            activeSection === 'projects' ? classes.isActive : ''
          }`}
          onClick={handleLinkClick[0]}
        >
          PROJECTS
          <div
            ref={p}
            className={`${classes.linkMarker} ${activeSection === 'projects' &&
              classes.showLinkMarker}`}
          />
        </a>
        <a
          className={`${classes.link} ${
            activeSection === 'about' ? classes.isActive : ''
          }`}
          onClick={handleLinkClick[1]}
        >
          ABOUT
          <div
            ref={a}
            className={`${classes.linkMarker} ${activeSection === 'about' &&
              classes.showLinkMarker}`}
          />
        </a>
        <a
          className={`${classes.link} ${
            activeSection === 'technologies' ? classes.isActive : ''
          }`}
          onClick={handleLinkClick[2]}
        >
          TECHNOLOGIES
          <div
            ref={t}
            className={`${classes.linkMarker} ${activeSection ===
              'technologies' && classes.showLinkMarker}`}
          />
        </a>
        <a
          className={`${classes.link} ${
            activeSection === 'contact' ? classes.isActive : ''
          }`}
          onClick={handleLinkClick[3]}
        >
          CONTACT
          <div
            ref={c}
            className={`${classes.linkMarker} ${activeSection === 'contact' &&
              classes.showLinkMarker}`}
          />
        </a>
      </nav>
    </header>
  );
};

export default Header;
